<div *ngIf="loaderSmallService.loading$ | async" nz-row>
    <div nz-col nzSpan="22">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    </div>
</div>
